import {Component, OnInit, ViewChild} from '@angular/core';
import { CKEditorComponent, CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { FormBuilder, FormControl, ReactiveFormsModule } from "@angular/forms";

import {
  GenericResponse, QuickNote
} from "../../../utilities/data-models";
import {MatSnackBar} from '@angular/material/snack-bar';
import {AppLoaderService} from "../../../global-services/app-loader/app-loader.service";
import {ApplicationInsightsService} from "../../../global-services/azure/insights-service/application-insights.service";
import {SeverityLevel, ProjectUtils} from "../../../utilities/project-utils";
import {CustomStorageService} from "../../../global-services/custom-storage.service";
import CustomCKEditor from "src/app/custom-ck-editor/ckeditor";
import { GenericHttpService } from '../../../global-services/generic-http.service';
import { UrlConstants } from '../../../utilities/url-constants';
import { MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { QuicklinkModule } from 'ngx-quicklink';
@Component({
    selector: 'app-notpad-modal',
    templateUrl: './notpad-modal.component.html',
    styleUrls: ['./notpad-modal.component.scss'],
    standalone: true,
    imports: [QuicklinkModule, MatDialogContent, CKEditorModule, ReactiveFormsModule, MatDialogActions, MatButtonModule, MatDialogClose]
})


export class NotpadModalComponent implements OnInit {
  ckEditorConfig: any;
  @ViewChild('noteEditor', {static: false}) noteEditor: CKEditorComponent;

  public Editor:any = CustomCKEditor;
  editorData = "";

  constructor(private fb: FormBuilder,
              private snackBar: MatSnackBar,
              private loader: AppLoaderService,
              private httpService: GenericHttpService,
              private insightService: ApplicationInsightsService,
              private customStorageService: CustomStorageService,) {
  }

  noteDescription = new FormControl();
  loggedInUserId: string;
  notesDetails: string;
  maxLimit: number = 50;
  disabledButton: boolean = false;
  displayCharacter: number;

  ngOnInit(): void {
    this.loggedInUserId = this.customStorageService.getItem(ProjectUtils.userIdLocKey);
    this.getStickyNotes();
    this.initForm(undefined);

    const maxCharacters = 4000;
    const container = document.querySelector('.demo-update');
    const progressCircle: any = document.querySelector('.demo-update__chart__circle');
    const charactersBox = document.querySelector('.demo-update__chart__characters');
    const wordsBox = document.querySelector('.demo-update__words');
    const circleCircumference = Math.floor(2 * Math.PI * progressCircle.getAttribute('r'));
    const sendButton = document.querySelector('.demo-update__send');

    this.ckEditorConfig = {
      toolbar: ['bold', 'italic', 'numberedList', 'bulletedList'],
      /*wproofreader : {
        lang: 'en_US', // sets the default language
        serviceId: environment.wproofreaderServiceID, // required for the Cloud version only
        srcUrl: environment.wproofreaderSrcUrl,
      },*/
      wordCount: {
        onUpdate: (stats: any) => {

          const charactersProgress = stats.characters / maxCharacters * circleCircumference;
          const isLimitExceeded = stats.characters > maxCharacters;
          const isCloseToLimit = !isLimitExceeded && stats.characters > maxCharacters * .8;
          const circleDashArray = Math.min(charactersProgress, circleCircumference);

          // Set the stroke of the circle to show how many characters were typed.
          progressCircle.setAttribute('stroke-dasharray', `${ circleDashArray },${ circleCircumference }`);

          // Display the number of characters in the progress chart. When the limit is exceeded,
          // display how many characters should be removed.
          if (isLimitExceeded) {
            this.disabledButton = true;
            charactersBox.textContent = `-${ stats.characters - maxCharacters }`;
          } else {
            this.disabledButton = false;
            charactersBox.textContent = stats.characters;
          }


          // Prints the current content statistics.
          if (stats.characters >= this.maxLimit) {

          }
          // If the character limit is exceeded, disable the send button.
          sendButton.toggleAttribute('disabled', isLimitExceeded);
          this.displayCharacter = stats.characters;
        }
      }
    };

  }

  initForm(quickNote: QuickNote) {
    if (quickNote != undefined) {
      this.noteDescription = new FormControl(quickNote?.NoteDescription);
    }
  }

  getStickyNotes() {
    this.httpService.get<GenericResponse<QuickNote>>(UrlConstants.getQuickNotes(this.loggedInUserId))
      .subscribe(res => {
        this.initForm(res.Result);
      }, error => {
        this.snackBar.open('Something went wrong ', 'OK', {duration: 2000});
      });
  }


  saveNote() {
    this.loader.open();

    const noteBody = {NoteDescription: this.noteDescription.value};

    this.httpService.put<GenericResponse<QuickNote>>(UrlConstants.addQuickNote(this.loggedInUserId), noteBody,true).subscribe(res => {
      this.loader.close();
      this.snackBar.open('Note added successfully', 'OK', {duration: 3000});

    }, error => {
      this.loader.close();
      this.snackBar.open('Unable to add or update note', 'OK', {duration: 3000});
      this.insightService.logException(error, 'notpad-modal.component',
        'onSubmit:PUT : ' + UrlConstants.activities,
        '116',
        SeverityLevel.Error);
    });


  }


}
